import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ExternalSessionService } from '../services/external-session.service';

/** External users pass with their own session; everyone else has to sign in with Microsoft. */
export const appAccessGuard: CanActivateFn = (route, state) => {
    const externalSession = inject(ExternalSessionService);
    switch (externalSession.status()) {
        case 'active':
            return true;
        case 'expired':
            // Never send an external user to the Microsoft sign-in: restart their own login instead.
            externalSession.end('expired');
            return false;
        default:
            return inject(MsalGuard).canActivate(route, state);
    }
};
